import { Input, InputNumber } from 'antd';
import React from 'react';
import { ControlProps } from '.';
import { InputType, MinMaxConstraintValue } from '../../types';

const SingleInput: React.FC<ControlProps> = ({
  placeholder,
  disabled,
  isDetail,
  inputType,
  digitalAccuracy,
  constraintValue,
  value,
  onChange,
  unit,
}) => {
  const Component = inputType === InputType.NUMBER ? InputNumber : Input;
  const { min, max } = constraintValue
    ? (constraintValue as MinMaxConstraintValue)
    : { min: undefined, max: undefined };

  if (isDetail) {
    return <div>{value?.value as string | number}</div>;
  }
  return (
    <Component
      style={{ width: 160 }}
      placeholder={placeholder ?? '请输入'}
      min={min}
      max={max}
      precision={digitalAccuracy}
      disabled={disabled}
      value={value?.value as string | number}
      onChange={e => {
        const v =
          inputType === InputType.NUMBER ? (e as number) : (e as React.ChangeEvent<HTMLInputElement>).target.value;
        onChange && onChange({ ...value, value: v });
      }}
    />
  );
};

export default SingleInput;
